export const setPageTitle = (title: string): void => {
  document.title = title
}
